import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import CSS from './MenuBtn.scss';
const Btn = ({ onClick, disabled, children, style = {}, id, classNames, onPointerUp, tabIndex, testId = 'Btn' }) => {
    const btnRef = useRef(null);
    let classes = classNames || [];
    if (typeof classes === 'string') {
        classes = [classes, CSS.Btn];
    }
    else
        classes = [...classes, CSS.Btn];
    return (_jsx("button", { "data-testid": testId, ref: btnRef, className: classes.join(' '), style: {
            opacity: disabled ? '0.3' : '1',
            ...style,
        }, disabled: disabled, onClick: (e) => {
            e.stopPropagation();
            onClick?.(btnRef, id, e);
        }, onPointerUp: (e) => {
            e.stopPropagation();
            onPointerUp?.(e);
        }, tabIndex: tabIndex, children: children }));
};
export default Btn;
